import axios from 'axios';

import type {
  JsonObject,
  IUserFindRequest,
  IUserFindResponse,
} from '@/app-package';

const findUser = async (userId: string) => {
  const config: IUserFindRequest = { url: `/user/${userId}`, method: 'get' };

  const { data } = await axios.request<JsonObject<IUserFindResponse>>(config);

  return data;
};

type User = IUserFindResponse;

export { findUser as find, User };
